

module.exports = {
  "../assets/home/banner.png": (function() { var id = 352; return __webpack_require__.t(id, 1); })(),
  "../assets/home/card.png": (function() { var id = 3792; return __webpack_require__.t(id, 1); })(),
  "../assets/home/card_building.png": (function() { var id = 8753; return __webpack_require__.t(id, 1); })(),
  "../assets/home/card_home.png": (function() { var id = 348; return __webpack_require__.t(id, 1); })(),
  "../assets/home/card_hotel.png": (function() { var id = 7271; return __webpack_require__.t(id, 1); })(),
  "../assets/home/card_safe.png": (function() { var id = 5294; return __webpack_require__.t(id, 1); })()
};
